module.exports = __webpack_public_path__ + "static/media/badgeReveal@2x.26ba5728.png";